import React from "react";

export type QuestionaireStyleProps = {
	question: string;
};
const QuestionaireStyle: React.FC<QuestionaireStyleProps> = ({ question }): JSX.Element => {
	const parts = question.split("*");

	return (
		<div
			style={{
				fontSize: "1.3rem",
				textAlign: "center",
				fontWeight: "bold",
				height: "3rem"
			}}
		>
			{parts.map((part, index) => (
				<React.Fragment key={index}>
					{index % 2 === 0 ? (
						<span>{part}</span>
					) : (
						<span style={{ fontWeight: "bolder", marginLeft: "5px", marginRight: "5px", color: "red" }}>
							{part}
						</span>
					)}
				</React.Fragment>
			))}
		</div>
	);
};

export default QuestionaireStyle;
